<template>
    <div class="order-history-page">
        
        <mt-header fixed title="订单动态" style="background:#ffffff;color:#262626;">
            <mt-button icon="back" slot="left" @click="goBack"></mt-button>
        </mt-header>

        <div class="main-section">
            <ul class="history-list">
                <li v-for="item in messages" :key="item.id">
                    <div class="icon"></div>
                    <div class="content">
                        <span class="text">{{item.subject}}</span><br/>
                        <span class="time">{{item.created_at | timeFormat}}</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

import moment from 'moment'

export default {
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            orderno: '',
            messages: []
        }
    },
    mounted(){
    },
    created(){
        this.orderno = this.$route.query.orderno
        this.getOrderHistory()
    },
    methods:{
        getOrderHistory(){
            let access_token = localStorage.access_token
            let data = {
                info: {
                    app_id: window.config.appid,
                    order_no: this.orderno
                },
                access_token: access_token
            }
            this.$store.dispatch('getMessages',data).then((res)=>{
                let result = res.data
                if(result.code == 0){
                    this.messages = result.res
                }
            })
        },
        goBack(){
            history.go(-1)
        }
    },
    components:{
    },
    filters:{
        timeFormat(val){
            return new moment(val).format('MM-DD hh:mm')
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/OrderHistory.vue